// Block bundles register here so fetched pages can reuse their own lifecycles.
const Page = {
  modules: new Set(),
  active: false,

  register(module) {
    this.modules.add(module)
    if (this.active) module.init()
  },

  init() {
    this.active = true
    this.modules.forEach(module => module.init())
  },

  destroy() {
    this.active = false
    Array.from(this.modules)
      .reverse()
      .forEach(module => module.destroy?.())
  }
}

export default Page
